var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-chart",class:[
        `z-chart--legend-position-${_vm.legend.position}`
    ]},[_c('div',{ref:"chart",staticClass:"z-chart__el"}),_vm._v(" "),_c('div',{ref:"legend",staticClass:"z-chart__legend"})])
}
var staticRenderFns = []

export { render, staticRenderFns }